import { Link } from "react-router-dom";
import { MarketingLayout } from "../components/MarketingLayout";

const CASES = [
  { title: "SaaS founders launching on Product Hunt", desc: "Ship a 60-second launch video and PH copy the same day you finish the product.", tag: "Founders" },
  { title: "Product teams shipping feature demos", desc: "Turn sprint screenshots into a walkthrough for customers, sales, and internal stakeholders.", tag: "Product" },
  { title: "Agencies creating client walkthroughs", desc: "Reuse templates across clients. Team workspaces with editor roles and brand kits.", tag: "Agencies" },
  { title: "Sales teams needing quick walkthroughs", desc: "Record a voice memo on your commute; get a polished demo before the next call.", tag: "Sales" },
  { title: "AI app builders launching new tools", desc: "From screenshots to launch-ready demo videos without learning Premiere or Final Cut.", tag: "Makers" },
  { title: "Marketing teams creating social clips", desc: "Generate TikTok, Reels, and LinkedIn short scripts alongside your main demo.", tag: "Marketing" },
];

export default function UseCases() {
  return (
    <MarketingLayout>
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="marquee-tag mb-4">// USE CASES</div>
        <h1 className="font-display font-black type-title-lg tracking-tighter mb-12">BUILT FOR TEAMS<br/>WHO SHIP FAST.</h1>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-0 brutal-border">
          {CASES.map((c, i) => (
            <div key={c.title} className={`p-8 border-b md:border-r brutal-border border-l-0 border-t-0 ${i % 2 === 1 ? "bg-surface" : ""}`}>
              <span className="text-xs uppercase tracking-widest text-ink-accent">{c.tag}</span>
              <h2 className="font-display font-black type-subheading mt-3 tracking-tight">{c.title}</h2>
              <p className="text-sm mt-3 text-ink-muted leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
        <div className="mt-12"><Link to="/register" className="brutal-btn">Try DemoCraft free</Link></div>
      </section>
    </MarketingLayout>
  );
}
